export const CHART_TYPE_TO_SUBTAB_LABELS_MAPPING: Record<string, Record<string, string>> = {
  soulMatrixChart: {
    general: 'Основные Аспекты',
    personal_qualities: 'Личные Качества',
    soul_comfort: 'Душевный Комфорт',
    self_realization: 'Самореализация',
    karmic_debt: 'Кармический Долг',
    purpose: 'Предназначение',
    programs: 'Программы',
    finances: 'Финансы',
    relationships: 'Отношения',
    talents: 'Таланты',
    karmic_tail: 'Кармический Хвост',
  },
  pythagoreanSquareChart: {
    general: 'Основные Аспекты',
    temperament: 'Темперамент',
    goal: 'Цель',
    family: 'Семья',
    habits: 'Привычки',
    spirituality: 'Духовность',
    talent: 'Талант',
    lifestyle: 'Быт',
    self_estimation: 'Самооценка',
    destiny_number: 'Число Судьбы',
    karma: 'Карма',
    character: 'Характер',
    duty: 'Долг',
    memory: 'Память',
    health: 'Здоровье',
    luck: 'Удача',
    energy: 'Энергия',
    logic: 'Логика',
    interest: 'Интерес',
    work: 'Труд',
  },
  crystalsChart: {
    general: 'Основные Аспекты',
    power_crystals: 'Камни Силы',
    family_crystals: 'Камни Семьи',
    health_crystals: 'Здоровье',
    safety_crystals: 'Безопасность',
    finance_crystals: 'Финансы',
    career_crystals: 'Карьера',
    communication_and_training_crystals: 'Коммуникация',
    social_activity_crystals: 'Самореализация',
  },
};
